export default class ServicesCreaterUtils {
    static Types = [
        //
        { id: "default", title: "Default" },
        { id: "pagenation", title: "Pagenation" },
    ];
    static getType = (type) => ServicesCreaterUtils.Types.find((t) => t.id === type);
}
